/** 生成UUID */
export const generateUUID = (prefix = 'uuid') => {
  let resUUID = ''
  if (typeof crypto === 'object') {
    if (typeof crypto.randomUUID === 'function') {
      resUUID = crypto.randomUUID()
    } else if (typeof crypto.getRandomValues === 'function' && typeof Uint8Array === 'function') {
      const callback = (c: any) => {
        const num = Number(c)
        return (num ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (num / 4)))).toString(
          16,
        )
      }
      resUUID = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, callback)
    }
  } else {
    let timestamp = new Date().getTime()
    let performanceNow =
      (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0
    resUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      let random = Math.random() * 16
      if (timestamp > 0) {
        random = (timestamp + random) % 16 | 0
        timestamp = Math.floor(timestamp / 16)
      } else {
        random = (performanceNow + random) % 16 | 0
        performanceNow = Math.floor(performanceNow / 16)
      }
      return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16)
    })
  }
  return `${prefix}_${resUUID}`
}

// 两个时间相差天数
export const getDaysDiff = (date1: number | string | Date, date2: number | string | Date) => {
  const oneDay = 24 * 60 * 60 * 1000 // 一天的毫秒数
  const timeDiff = Math.abs(new Date(date1).getTime() - new Date(date2).getTime())
  return Math.round(timeDiff / oneDay)
}

export const goTop = () => {
  // 直接设置滚动位置
  document.documentElement.scrollTop = 0;
  // 旧版浏览器兼容性
  document.body.scrollTop = 0;
  // 移动端兼容
  const appBox = document.getElementById('app')
  if (appBox) appBox.scrollTop = 0
}

export const withTimeout = <T>(promise: Promise<T>, timeout: number): Promise<T> => {
  return Promise.race([
    promise,
    new Promise<never>((_, reject) => {
      setTimeout(() => reject(new Error('请求超时')), timeout)
    })
  ])
}

export const isMobile = () => {
  // 判断是否为移动设备
  return window.innerWidth <= 450; // 根据实际情况设置判断的界限
};

export const sleep = (t: number) => {
  return new Promise<void>((res) => {
    setTimeout(() => {
      res();
    }, t);
  });
};
